import React from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';

export default function SingleQA({
  item,
  onClick,
  active,
  number = 1,
  activeButtonStyle = '',
  singleQaClass = '',
}: {
  item: any;
  onClick: (x: any) => void;
  active: any;
  number?: number;
  activeButtonStyle?: string;
  singleQaClass?: string;
}) {
  return (
    <div
      onClick={() => {
        onClick(item);
      }}
      className={`${styles.container} ${singleQaClass} ${active?.id == item?.id && styles.activeCard}`}
    >
      <div className={`${styles.qa} `}>
        <p className={`${styles.question}`}>
          <p>
            {/* <span className={`${styles.number}`}>{number + '.'}</span> */}
            {item?.question}
          </p>
          {/* {active?.id != item?.id &&  */}
          {/* <MainIcons.arrowLongIcon fill={`#E3E3E3`} /> */}
          <span
            className={`${styles.plus} ${active?.id == item?.id && `${styles.activeIcon} ${activeButtonStyle}`} `}
          >
            +
          </span>
          {/* } */}
        </p>
        <p
          className={`${styles.answer} ${active?.id == item?.id ? styles.showAnswer : styles.hideAnswer}`}
        >
          {item?.answer}
        </p>
      </div>
    </div>
  );
}
